<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="">Copyright © 2024 <a target="_blank" href="https://arrangic.com">Grupo Italcol</a>, Todos los derechos reservados.</p>
        </div>
    </div>
    <!-- END FOOTER -->
</template>
<script>
    export default {
        data() {
            return {};
        },
        mounted() {},
        methods: {}
    };
</script>
